import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ProductGet, ProductService } from '@app/services/product.service';
import { ProductComponent } from '../product.component';

@Component({
    selector: 'tt-product-edit-save',
    templateUrl: './product-edit-save.component.html',
    styleUrls: ['./product-edit-save.component.css'],
})
export class ProductEditSaveComponent implements OnChanges {
    @Input()
    public params?: ProductGet;

    @Input()
    public saving = false;

    @Output()
    public savingChange = new EventEmitter<boolean>();

    @Output()
    public saved = new EventEmitter<void>();

    @Input()
    public set disabled(value: BooleanInput) {
        this._disabled = coerceBooleanProperty(value);
    }
    public get disabled(): boolean {
        return this._disabled;
    }
    private _disabled = false;

    constructor(
        private product: ProductService,
        private modal: ModalService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, ProductComponent);
    }

    public async save() {
        if (!this.params) return;

        try {
            this.saving = true;
            this.savingChange.emit(this.saving);
            this.cdr.markForCheck();

            const { errorcode, errormessage } = await this.product.saveProduct(this.params);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.saved.emit();
                this.navigator?.back();
                this.cdr.markForCheck();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
            this.savingChange.emit(this.saving);
            this.cdr.markForCheck();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disabled']) {
            this.disabled = changes['disabled'].currentValue;
        }
    }
}
